import { signal } from "@preact/signals-react";
export const refreshStaffScheduleById = signal<string | null>(null);
export const refreshVehicleScheduleById = signal<{
  vehicleId: string;
  date: string;
} | null>(null);
